import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Box,
  IconButton,
  Tooltip as MuiTooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const OrdendeVentaPerfectaBarChart = () => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getPerfectSalesOrder, dataReady } = useData();

  // Get data from Excel (3 years)
  const excelData = dataReady ? getPerfectSalesOrder() : { labels: [], data2022: [], data2023: [], data2024: [] };

  // Use Excel data or fallback
  const labels = excelData.labels.length > 0
    ? excelData.labels
    : ['Sector Salud/ Farmacéuticas', 'Automotriz', 'Manufactura', 'Construcción', 'Retail', 'Alimentos', 'Servicios Logísticos'];

  const data2022 = excelData.data2022.length > 0 ? excelData.data2022 : [90, 83, 92, 90, 90, 91, 89];
  const data2023 = excelData.data2023.length > 0 ? excelData.data2023 : [100, 92, 91, 96, 88, 95, 97];
  const data2024 = excelData.data2024.length > 0 ? excelData.data2024 : [98, 91, 92, 94, 92, 95, 96];

  const chartData = {
    labels,
    datasets: [
      {
        label: '2023',
        data: data2022,
        backgroundColor: '#A2AEBB',
      },
      {
        label: '2024',
        data: data2023,
        backgroundColor: '#476A8E',
      },
      {
        label: '2025',
        data: data2024,
        backgroundColor: '#1F3D58',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 40,
        bottom: 20,
        left: 10,
        right: 10,
      },
    },
    plugins: {
      legend: {
        position: 'top',
        labels: { font: { size: 12, weight: 'bold' } },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        anchor: 'end',
        align: 'top',
        offset: (context) => {
          // Stagger labels vertically to avoid overlap
          return context.datasetIndex === 0 ? 2 : context.datasetIndex === 1 ? 12 : 22;
        },
        formatter: (value) => `${value}%`,
        font: { weight: 'bold', size: 9, },
        color: '#000',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 120,
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
        ticks: {
          stepSize: 10,
        },
      },
      x: {
        title: {
          display: true,
          text: 'Industria',
        },
      },
    },
  };

  const infoContent = {
    formula:
      'Orden de Venta Perfecta (%) = (Órdenes completas, a tiempo y sin errores / Total de órdenes realizadas) × 100',
    description:
      'Mide la proporción de órdenes de ventas entregadas a tiempo y completas.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <div style={{ width: '100%', height: '450px', display: 'flex',justifyContent: 'center', alignItems: 'center',  }}>
        <Bar data={chartData} options={options} />
      </div>
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OrdendeVentaPerfectaBarChart;
